import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { SessionStorageService } from 'src/app/_services/session-storage.service';
import { RegisterState, FirstStepData, SecondStepData } from 'src/app/models/register-state.interface';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit, OnDestroy {
  private readonly REGISTER_STATE_KEY = 'register_state';
  
  step: number = 0;
  selectedRole: string = '';
  particularForm: any;
  providerForm: any;
  form: any;
  
  constructor(
    private fb: FormBuilder, 
    private navController: NavController,
    private sessionStorageService: SessionStorageService
  ) {
  }
  ngOnInit() {
    this.restoreRegisterState();
  }

  ionViewWillEnter() {
    // This ensures state is restored every time the page is entered
    this.restoreRegisterState();
  }

  ngOnDestroy() {
    this.saveRegisterState();
  }

  // get f() {
  //   return this.registerForm.controls;
  // }

  nextSteps(stepper: any) {
    this.step = stepper;
    this.saveRegisterState();
  }

  prev(stepper: any) {
    this.step = stepper;
    this.saveRegisterState();
  }

  stepVal($event: any) {
    this.step = $event;
    this.saveRegisterState();
  }
  submitForm() {

  }
  backto(step: number) {
    switch (step) {
      case 0:
        this.navController.pop();
        break;
      default:
        this.step = step !== 0 ? step - 1 : 0
        break;
    }

  }

  handleRoleSelection(role: string) {
    this.selectedRole = role;
    this.saveRegisterState();
  }

  updateForm(step: number, form: any) {
    switch (this.selectedRole) {
      case 'particulier':
        this.form = form;
        break;

      default:
        this.form = form;
        break;
    }
    
    // Save form data to session storage
    this.saveFormData(step, form);
  }

  /**
   * Save register state to session storage
   */
  private saveRegisterState(): void {
    const registerState: RegisterState = {
      currentStep: this.step,
      selectedRole: this.selectedRole,
      firstStepData: this.form,
      timestamp: Date.now()
    };
    
    this.sessionStorageService.saveRegisterState(registerState);
  }

  /**
   * Restore register state from session storage
   */
  private restoreRegisterState(): void {
    const redirectInfo = this.sessionStorageService.shouldRedirectToStep();
    
    if (redirectInfo.shouldRedirect) {
      this.step = redirectInfo.step;
      this.selectedRole = redirectInfo.role;
      
      // Restore form data based on current step
      if (this.step === 1) {
        this.form = this.sessionStorageService.getRegisterFirstStep();
      } else if (this.step === 2) {
        this.form = this.sessionStorageService.getRegisterFirstStep();
      }
      
    } else {
      // Initialize with default values
      this.step = 0;
      this.selectedRole = '';
      this.form = null;
      this.handleRoleSelection('particulier');
      this.clearRegisterState();
    }
  }

  /**
   * Check if the saved state is valid and complete enough to restore
   */
  private isValidState(state: RegisterState): boolean {
    // Must have at least a role and step
    return !!(state.selectedRole && state.currentStep !== undefined);
  }

  /**
   * Save form data for specific step
   */
  private async saveFormData(step: number, formData: any): Promise<void> {
    await this.sessionStorageService.updateRegisterState(step, formData, this.step, this.selectedRole);
  }

  /**
   * Clear register state from session storage
   */
  public clearRegisterState(): void {
    this.sessionStorageService.clearRegisterState();
  }

  /**
   * Get current register state
   */
  public getCurrentState(): RegisterState | null {
    return this.sessionStorageService.getRegisterState();
  }

  /**
   * Get register progress information
   */
  public getRegisterProgress() {
    return this.sessionStorageService.getRegisterProgress();
  }

  /**
   * Clear register state after successful registration
   */
  public clearRegisterStateAfterSuccess(): void {
    this.sessionStorageService.clearRegisterState();
    this.step = 0;
    this.selectedRole = '';
    this.form = null;
  }

  /**
   * Check if user has incomplete registration data
   */
  public hasIncompleteRegistration(): boolean {
    return this.sessionStorageService.hasRegisterData();
  }
}
